import * as utils from "../../utils/utils";
import useBrandTranslation from "../../hooks/useBrandTranslation";

export default function AuthPageLoader({ message }) {
  const { t } = useBrandTranslation();

  return (
    <div className="flex min-h-screen w-full flex-col items-center justify-center bg-cold-white px-6">
      <img
        src={utils.getBrandAnimatedLoaderSrc()}
        alt={t("auth.loadingLogoAlt", "Cargando")}
        className="h-12 w-auto max-w-[min(100%,280px)] object-contain"
      />
      {message !== false && (
        <p className="mt-6 text-sm text-gray-500">
          {message || t("auth.loading", "Cargando...")}
        </p>
      )}
    </div>
  );
}
